import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import PersonIcon from '@mui/icons-material/Person';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

import { AuthContext } from '../../context/AuthContextProvider';
import PrimaryButton from '../../components/PrimaryButton';
import RoundedInput from '../../components/RoundedInput';
import LocalitySelect from '../../components/LocalitySelect';
import AutoNavigate from '../../components/AutoNavigate';
import { defaultApiClient } from '../../apiClients/apiClient';

const localityOptions = ['Renaissance Park 1', 'Renaissance Park 2', 'Renaissance Park 3'];

export default function SignUpPage() {
    const navigate = useNavigate();

    const { signUpRequest, setLoginOtpRequest, setSignUpRequest, setTokens } =
        useContext(AuthContext);

    const [isRequestingPhoneVerificationOtp, setIsRequestingPhoneVerificationOtp] = useState(false);
    const [fullName, setFullName] = useState(signUpRequest?.fullName || '');
    const [locality, setLocality] = useState(signUpRequest?.locality || '');
    const [phoneNumber, setPhoneNumber] = useState(signUpRequest?.phoneNumber || '');

    const handleCreateAccountButtonClick = async () => {
        if (fullName.trim().length < 3) {
            window.alert('Please enter your full name.');
            return;
        }

        if (locality.trim().length === 0) {
            window.alert('Please select your locality.');
            return;
        }

        if (phoneNumber.trim().length < 10) {
            window.alert('Please enter a valid phone number.');
            return;
        }

        let standardizedPhoneNumber = phoneNumber.replace(' ', '');
        if (standardizedPhoneNumber.length === 10) {
            standardizedPhoneNumber = '+91' + standardizedPhoneNumber;
        } else if (standardizedPhoneNumber.length === 12) {
            standardizedPhoneNumber = '+' + standardizedPhoneNumber;
        }

        setIsRequestingPhoneVerificationOtp(true);

        const requestSignUpOtpResponse = await defaultApiClient.methods.auth.requestSignupOtp(
            standardizedPhoneNumber
        );
        if (!requestSignUpOtpResponse.success) {
            console.log(requestSignUpOtpResponse);
            window.alert(
                `${requestSignUpOtpResponse.error.userFriendlyError.title}: ${requestSignUpOtpResponse.error.userFriendlyError.detail}`
            );
            setIsRequestingPhoneVerificationOtp(false);
            return;
        }

        setSignUpRequest({
            phoneNumber: standardizedPhoneNumber,
            fullName: fullName,
            locality: locality,
            state: 'VERIFY_SIGNUP_OTP',
        });
        navigate('/auth/verify-signup-otp');
    };

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            {/* <AutoNavigate /> */}
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <img src="/text-icon-high-res.png" style={{ height: '7vh' }} />
                <img src="/login.png" style={{ height: '25vh' }} />
                <Typography variant="h5" mt={2}>
                    Create Your Account
                </Typography>
            </Box>

            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        width: '80%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mb: 2,
                    }}
                >
                    <RoundedInput
                        placeholder="Enter name"
                        icon={<PersonIcon />}
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        type="text"
                        marginBottom={2}
                    />

                    <LocalitySelect
                        locality={locality}
                        setLocality={setLocality}
                        options={localityOptions}
                        marginBottom={2}
                    />

                    <RoundedInput
                        placeholder="Enter phone number"
                        icon={<LocalPhoneIcon />}
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        type="tel"
                    />
                </Box>

                <PrimaryButton
                    text="Create Account"
                    fontSizeOverride={16}
                    onClick={handleCreateAccountButtonClick}
                    loading={isRequestingPhoneVerificationOtp}
                    disabled={isRequestingPhoneVerificationOtp}
                />

                <Typography>
                    Already have an account?{' '}
                    <Link
                        href="/auth/login"
                        underline="always"
                        sx={{
                            color: 'rgb(39,90,71)',
                            textDecorationColor: 'rgb(39,90,71)',
                            fontWeight: 500,
                            '&:visited': {
                                color: 'rgb(39,90,71)',
                            },
                            '&:hover': {
                                color: 'rgb(39,90,71)',
                            },
                        }}
                    >
                        Press Here to Log in
                    </Link>
                </Typography>
            </Box>
        </Box>
    );
}
